import '../../../../styles/scss/courses/courses.scss'
import { Helmet } from 'react-helmet'
import { CoursesCard } from './CoursesCard'
import { useEffect, useState } from 'react'
import * as API_COURSES from '../../../../shared/http/courses'
import { SmallCourseDto } from '../../../../shared/types/api'
import Loading from '../../../elements/loading/Loading'
import {Card, Col, Flex, Row, Skeleton, Spin} from 'antd'
import { NoAuthGEButton } from '../../../../common/buttons/no-auth-gebtn'
import { useNavigate } from 'react-router-dom'
import { goToPageNotPremium } from '../../../utils/goToPage'
import { NavigationPages } from '../../../../common/navigation/navigation-pages'
import PrivilegesUtil from '../../../utils/PrivilegesUtil'
import Privileges from '../../../../const/Privileges'
import { useAppSelector } from '../../../../store/hooks'
import { userSelector } from '../../../../store/global'

export const CoursesSkeleton = () => {

    const CARD_W = 490;
    return (


        <Row gutter={[16, 16]} justify="start" style={{margin:16}}>
            {[...Array(16)].map((_, idx) => (
                <Col key={idx} flex={`0 0 ${CARD_W}px`}>
                    <Card
                        hoverable
                        style={{ width: CARD_W, margin: '0 auto' }}
                        cover={
                            <div style={{ padding: 8, display: 'flex', justifyContent: 'center' }}>
                                <Skeleton.Image active style={{ width: 458, height: 208, borderRadius: 8 }} />
                            </div>
                        }
                    >
                        {/* Контент карточки */}
                        <Flex vertical style={{ minHeight: 100 }}>
                            <div style={{ flex: 1 }} />
                            <Skeleton active paragraph={{ rows: 3 }} />
                        </Flex>
                    </Card>
                </Col>
            ))}
        </Row>
    )
}